export default __webpack_public_path__ + "static/media/Flag_of_Albania.dd17f9b0.svg";